// lt-edit
class RequestProductButton extends HTMLElement {
  async connectedCallback() {
    if (document.readyState === 'loading') {
      await new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve, { once: true }));
    }

    this.addEventListener('pointerup', () => {
      this.dispatchEvent(new CustomEvent('productrequest:type', {
        bubbles: true, detail: {
          value: 'quote-request'
        }
      }));
      this.dispatchEvent(new CustomEvent('productrequest:toggle', { bubbles: true }));
    });
  }
}

customElements.define('request-product-button', RequestProductButton);
